export const requiredText = 'Обязательное поле!'
